import { FlowActions } from "../../stores/flowStore"

export function useAddReceiptTransaction() {
  return FlowActions.addReceiptTransaction
}
